import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

/*
 * The prototype's "● LIVE" pixel badge - green on a near-black chip. Used on
 * server/game cards and the game banner.
 */
export function LiveBadge({ className }: { className?: string }) {
  const { t } = useTranslation('common');

  return (
    <span
      className={cn(
        'font-display inline-flex items-center gap-1 border border-[#3d5c2e] bg-[#14161a] px-1.5 py-0.5 text-[9px] uppercase tracking-wide text-[#8ed065]',
        className,
      )}
    >
      <span aria-hidden>●</span> {t('status.live')}
    </span>
  );
}
